import { createContext, useContext } from 'react';

/** True when a page renders inside the marketplace shell, so legacy parts (such as the gradient hero) can drop to a plain heading. */
export const InShellContext = createContext(false);
export const useInShell = () => useContext(InShellContext);
